// extracted by mini-css-extract-plugin
export default {"transactions":"transactions__transactions--tcayV"};